exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".accordion[data-v-22a17024]{list-style:none;margin:0;padding:0}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Dashboard/Accordion.vue"],"names":[],"mappings":"AACA,4BACE,gBAAiB,AACjB,SAAU,AACV,SAAW,CAKZ","file":"Accordion.vue","sourcesContent":["\n.accordion[data-v-22a17024] {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n\n  /* &__item:last-child {\n    border-bottom: none;\n  } */\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22a17024","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Dashboard/Accordion.vue
// module id = 2073
// module chunks = 16